<template>
  <div class="card">
    <div class="card-header bg-dark">
      <h3 class="mb-0 text-white">
        รายการเงินเข้า
        <small class="ml-1">({{ count | format(0) }} ครั้ง)</small>
      </h3>
    </div>

    <el-table
      row-key="id"
      header-row-class-name="thead-light"
      :data="queriedData"
    >
      <el-table-column label="ธนาคาร" min-width="125px">
        <div slot-scope="{ row }">
          <b>
            {{ row.bankType | bankName }}
            <small>({{ row.provider | providerName }})</small>
          </b>
          <br />
          {{ row.bankAccount }}
        </div>
      </el-table-column>
      <el-table-column label="จำนวน" min-width="100px" prop="amount" sortable>
        <div slot-scope="{ row }">
          {{ row.amount | format }}
        </div>
      </el-table-column>
      <el-table-column label="รายละเอียด" min-width="200px">
        <div slot-scope="{ row }">
          {{ row.remark }}
        </div>
      </el-table-column>
      <el-table-column label="วันที่/เวลา" min-width="100px">
        <div slot-scope="{ row }">
          {{ row.createdAt | moment("DD/MM/YYYY HH:mm") }}
        </div>
      </el-table-column>
      <el-table-column label="สถานะ" min-width="100px" align="center">
        <div slot-scope="{ row }">
          <span class="badge badge-success" v-if="row.status === 'success'">
            ดำเนินการสำเร็จ
          </span>
          <span
            class="badge badge-danger"
            v-else-if="row.status === 'duplicate'"
          >
            รายการซ้ำ
          </span>
          <span
            class="badge badge-danger"
            v-else-if="row.status === 'member_notfound'"
          >
            ไม่พบสมาชิก
          </span>
          <span
            class="badge badge-primary"
            v-else-if="row.status === 'pending'"
          >
            รอตรวจสอบ
          </span>
          <span class="badge badge-warning" v-else>
            {{ row.status }}
          </span>
        </div>
      </el-table-column>
    </el-table>

    <div class="card-footer border-0 d-flex justify-content-between">
      <p class="card-category">
        Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
      </p>

      <base-pagination
        :per-page="pagination.perPage"
        :total="total"
        v-model="pagination.currentPage"
      />
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";

import moment from "moment";
import BonusService from "../../services/bonus.service";
import tablePagination from "../../mixins/tablePagination";

export default {
  props: ["data", "count", "_searchQuery"],
  mixins: [
    tablePagination(
      ["bankType", "bankAccount", "amount", "remark", "createdAt"],
      25
    ),
  ],
  components: {
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  created() {
    this.updateTableData(this.data);
  },
  watch: {
    data(v) {
      this.updateTableData(v);
    },
    _searchQuery(v) {
      this.searchQuery = v;
    },
  },
};
</script>
